import { siglaDoFicheiro } from '@viewer/lib/nomeDoModelo'

// ---------------------------------------------------------------------------
// A especialidade de cada modelo (ARQ, EST, MAC, HID, EEL).
//
// A classificacao dos conflitos precisa de saber quem e quem: uma laje do
// EST e um pavimento do ARQ pedem regras diferentes. A sigla sai do nome
// do ficheiro pela mesma funcao que da o nome curto do modelo em toda a
// plataforma (`siglaDoFicheiro`, viewer/lib/nomeDoModelo.ts); aqui so se
// traduzem os sinonimos para as cinco especialidades das regras (AVAC e
// MEC contam como MAC, AGU e ESG como HID, ELE como EEL). O utilizador
// corrige no mapa modelo -> especialidade, que fica gravado com a
// triagem.
// ---------------------------------------------------------------------------

export type Especialidade = 'EST' | 'ARQ' | 'MAC' | 'HID' | 'EEL'

export const ESPECIALIDADES_DA_CLASSIFICACAO: Especialidade[] = ['EST', 'ARQ', 'MAC', 'HID', 'EEL']

export const NOME_DA_ESPECIALIDADE: Record<Especialidade, string> = {
  EST: 'Estruturas',
  ARQ: 'Arquitectura',
  MAC: 'AVAC / Mecânica',
  HID: 'Hidráulica',
  EEL: 'Electricidade',
}

/** Redes (MEP). */
export const REDES: ReadonlySet<Especialidade> = new Set(['MAC', 'HID', 'EEL'])

/** Sigla do nome do ficheiro -> especialidade das regras. As siglas sem
 *  regras proprias (GAS, SEG, TEL, PAV, TOP) ficam sem especialidade. */
const SINONIMOS: Record<string, Especialidade> = {
  ARQ: 'ARQ',
  EST: 'EST',
  MAC: 'MAC',
  AVAC: 'MAC',
  MEC: 'MAC',
  HID: 'HID',
  AGU: 'HID',
  ESG: 'HID',
  EEL: 'EEL',
  ELE: 'EEL',
}

/** A especialidade deduzida do nome do ficheiro, ou null. */
export function deduzirEspecialidade(nomeDoFicheiro: string): Especialidade | null {
  const sigla = siglaDoFicheiro(nomeDoFicheiro)
  return sigla ? (SINONIMOS[sigla] ?? null) : null
}

export type MapaDeEspecialidades = Record<string, Especialidade | null>

/** O mapa modelo -> especialidade: o que o utilizador corrigiu, e o
 *  deduzido para os outros. */
export function mapaDeEspecialidades(
  modelos: readonly { id: string; fileName: string }[],
  corrigido: MapaDeEspecialidades = {},
): MapaDeEspecialidades {
  const out: MapaDeEspecialidades = {}
  for (const m of modelos) {
    out[m.id] = m.id in corrigido ? corrigido[m.id] : deduzirEspecialidade(m.fileName)
  }
  return out
}

export function isEspecialidade(v: unknown): v is Especialidade {
  return v === 'EST' || v === 'ARQ' || v === 'MAC' || v === 'HID' || v === 'EEL'
}
